module.exports = __webpack_public_path__ + "img/icon-30.73318148.png";